import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@luggagehero/services';
import { SharedFeatureBagImageInputComponent } from '@luggagehero/shared-feature-bag-image-input';
import { SharedFeatureBookingsStorageRoomAccessInfoComponent } from '@luggagehero/shared-feature-bookings-storage-room-access-info';
import { FileUploadModule } from 'ng2-file-upload';
import { RatingModule } from 'ngx-bootstrap/rating';

import { BOOKINGS_COMPONENTS, BookingsUserComponent, ManageBookingSelectorComponent } from '../bookings/components';
import { UiModule } from '../ui/ui.module';

const prefix = 'bookings';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild([
      { path: prefix, component: BookingsUserComponent, canActivate: [AuthGuard] },
      { path: prefix + '/:id', component: ManageBookingSelectorComponent },
      { path: prefix + '/user/list', component: BookingsUserComponent, canActivate: [AuthGuard] },
    ]),
    RatingModule.forRoot(),
    FileUploadModule,
    UiModule,
    SharedFeatureBagImageInputComponent,
    SharedFeatureBookingsStorageRoomAccessInfoComponent,
  ],
  declarations: [...BOOKINGS_COMPONENTS],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BookingsModule {}
